const { default: axios } = require("axios");
import JsLoading from "./JsLoading";

const EventsAjax = function () {

    const removeWishList = (e) => {

        let el = $(e.currentTarget);

        JsLoading.showLoading(el);

        setTimeout(() => {
            el.parent().fadeOut(300);
            JsLoading.hideLoading(el);
        }, 2000);

        /* var el = $(e.currentTarget)
         
        $(el.data("target")).fadeOut(300);

        var url_ajax = el.data("ajax");
 */

        /* $.ajax({
            type: "DELETE",
            headers: {
                'X-CSRF-TOKEN': CSRF_TOKEN
            },
            url: url_ajax,
            dataType: "json",
            data: {
                return_json: true
            },
            success: function (data) {
                
                console.log('removido co msucesso');
                
            },
            error: function (jqXHR, textStatus, errorThrown) {
            }
        }); */
    }

    const elmFilter = (e, status) => {
        let el = $(e);
        if(status){
            el.closest('.wrap-bar-filter').find('.filter-menu').addClass(status);
        } else {
            el.closest('.wrap-bar-filter').find('.filter-menu').toggleClass('actived');
        }
    }

    const seeMore = (e) => {
        e.preventDefault();

        let el                  = $(e.currentTarget);
        let nextPage            = parseInt(el.attr('data-page'));
        let categoryPage        = parseInt(el.attr('data-category'));
        let urlAjax             = el.attr('data-url');
        let totalShowForPage    = parseInt(el.attr('data-totalpage'));
        const lastElmList       = $("#ajax-list-dinamic");
        // var nextPage = urlAjax;
        // console.log(nextPage);

        el.addClass('bt-loading');

        el.prop('disabled', true);
        
        JsLoading.showLoading(el);

        //detect controller
        let pagController = '';
        switch (categoryPage) {
            case 8:
                pagController = 'collections';
                break;
            case 9:
                pagController = 'projects';
                break;
        
            default:
                pagController = 'products';
                break;
        }
        
        axios.get(urlAjax, {
            headers: {'X-Requested-With': 'XMLHttpRequest', "Ajax-Request": true}
        })
        .then(function (response) {

            console.log(pagController, categoryPage);

            el.removeClass('bt-loading');

            // console.log(response.data);

            nextPage = nextPage + 1;
            //urlAjax = urlAjax.split(pagController+'/')[0]+pagController+'/'+categoryPage+'/'+nextPage+'/'+totalShowForPage;
            // urlAjax = urlAjax+'/'+pagController+'/'+categoryPage+'/'+nextPage+'/'+totalShowForPage;
            lastElmList.append(response.data.result.html);
            el.attr('data-page', nextPage);
            el.attr('data-url', response.data.result.url);
            // console.log(urlAjax);
            // window.history.pushState({ url: window.location.href }, null, urlAjax.split(pagController+'/')[0]+pagController+'/'+categoryPage+'/'+(nextPage -1)+'/'+totalShowForPage);
            window.history.pushState({ url: window.location.href }, null, response.data.result.url);

            console.log(response.data.result.hasNext);
            if( response.data.result.hasNext != true ) {
                $('.bt-link.ajax-more').fadeOut(300);
            }

        })
        .catch(function (error) {
                // handle error
            console.log(error);
        })
        .finally(function () {
            JsLoading.hideLoading(el);
            el.prop('disabled', false);
        });
    }

    const statusSwitch = (e) => {
        var el = $(e.currentTarget);
        console.log(el.is(':checked'));
    }

    //search in site
    const searchSite = (e) => {
        e.preventDefault();
        let formS = $(e.currentTarget);
        let wordSearch = formS.find('[name=search]').val();

        let urlAction = formS.attr('action');
        urlAction = urlAction + '/' + wordSearch;

        console.log(urlAction);
        console.log(formS);

        // formS.trigger('submit');
        document.getElementById("form-search-main").submit();

    }

    return {

        init : () => {
            
            //remove element of list wishlist
            $(document).on('click', '.remove-wishlist-ajax', removeWishList);

            //show or hide menu filter in products and collections
            $(document).on('click', '.toggle-filter-menu', function(){
                elmFilter($(this));
            });
         //filters get value of switch
            $(document).on('change', '#show-news', statusSwitch);

            // click ver mais
            $(document).on('click', '.ajax-more', seeMore);

            //search site
            $(document).on('submit', '#form-search-main', searchSite);

            /*check exist filter in page to hide tools*/

            //check tool filter
            if(!document.querySelector('.toggle-filter-menu')) {
                document.getElementById('tool-filter').classList.remove('d-md-inline-block');                
            } else {
                $(document).on('click', "#tool-filter", function(){
                    setTimeout(() => {
                        elmFilter('.toggle-filter-menu', 'actived');
                    }, 1000);
                })
            }

        }

    }
}();

export default EventsAjax;